import { Card, Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPalette,
  faCode,
  faShieldHalved,
  faUsers,
  faUser,
  faCreditCard,
  faBolt,
  faClock,
  faBell
} from '@fortawesome/free-solid-svg-icons';

interface Item {
  to: string;
  label: string;
  icon: any;
  end?: boolean;
}

// Grouped, real sections only. Dead/placeholder items are intentionally gone;
// new sections get added here as they're built.
const groups: { title: string; items: Item[] }[] = [
  {
    title: 'Workspace',
    items: [
      { to: '/settings', label: 'Widget appearance', icon: faPalette, end: true },
      { to: '/settings/availability', label: 'Availability & hours', icon: faClock }
    ]
  },
  {
    title: 'Channels',
    items: [{ to: '/settings/install', label: 'Install / embed', icon: faCode }]
  },
  {
    title: 'Automation',
    items: [{ to: '/settings/saved-replies', label: 'Saved replies', icon: faBolt }]
  },
  {
    title: 'Security',
    items: [{ to: '/settings/domains', label: 'Allowed domains', icon: faShieldHalved }]
  },
  {
    title: 'Account',
    items: [
      { to: '/agents', label: 'Teammates', icon: faUsers },
      { to: '/settings/notifications', label: 'Notifications', icon: faBell },
      { to: '/user-account', label: 'Profile', icon: faUser },
      { to: '/billing', label: 'Billing', icon: faCreditCard }
    ]
  }
];

const SettingsNav = () => {
  return (
    <Card style={{ minWidth: 230 }}>
      <Card.Body className="p-2">
        {groups.map(g => (
          <div key={g.title} className="mb-3">
            <div className="fs-10 text-uppercase text-body-tertiary fw-bold px-2 mb-1">
              {g.title}
            </div>
            <Nav className="flex-column">
              {g.items.map(item => (
                <Nav.Link
                  key={item.to}
                  as={NavLink}
                  to={item.to}
                  end={item.end}
                  className="d-flex align-items-center gap-2 px-2 py-2 rounded settings-nav-link"
                >
                  <FontAwesomeIcon icon={item.icon} className="fs-9 text-body-tertiary" fixedWidth />
                  <span className="fs-9">{item.label}</span>
                </Nav.Link>
              ))}
            </Nav>
          </div>
        ))}
      </Card.Body>
    </Card>
  );
};

export default SettingsNav;
